export default __webpack_public_path__ + "static/media/scion.79b5a5a5.svg";